//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import * as axios from "@/store/http";
export default {
    name: "stepsFlow",
    //控件属性
    props:{
        process:{type:Object,require: true}, //流程实例ID
        // flow_keyval:{type:String,require: false}, //流程实例ID
        // flow_btype:{type:String,require: true}, //流程实例ID
        record:{type:Object,require: false}, //业务数据
    },
    data() {
        return {
            clientWidth: 0,
            maxLength: 10,
            cols: 6, // 一行展示的步骤数
            flowData: []
        }
    },
    methods: {
        maxSlice (v) {

          let titleWidth = this.clientWidth/6-10;
          this.maxLength = titleWidth/20;
          console.log(this.maxLength);
          return v.length > this.maxLength ? v.slice(0, this.maxLength) + '...':v ;
        },
        setFloatClass(index) {
            let rowIndex = parseInt(index / this.cols); // 该步骤在第几行
            let isOddRow = rowIndex % 2 === 0 ? true : false; // 是否为偶数行
            if(isOddRow) {
                return "fl";
            } else {
                return "fr";
            }
        },
        setRoWEndClass(index) {
            let rowIndex = parseInt(index / this.cols); // 该步骤在第几行
            let RowEndIndex = rowIndex * this.cols;
            if(index !== 0 && index === RowEndIndex) {
                return "rowEnd";
            }
            return "";
        },
        /**
         * 加载流程预判数据
         */
        loadData() {
            // console.log(this.$route.query.piid);
            // console.log(this.$route.params.piid);
            let vkeyval;
            let vbtype;
            let vcondfieldval;
            let vrecord;
            let vpiid = this.$route.query.piid;

            if(vpiid == undefined){
              vpiid = this.process.processid;
              vkeyval = this.process.flow_keyval;
              vbtype= this.process.flow_btype;
              vrecord = this.record;
            }
            else{
              vkeyval = this.$route.query.flow_keyval;
              vbtype = this.$route.query.flow_btype;
              vcondfieldval = this.$route.query.condfieldval;
            }
 
            let params = {piid: vpiid,flow_keyval:vkeyval,flow_btype:vbtype,condfieldval:vcondfieldval,record:vrecord};
            //获取后端数据
            axios.post("flowProcess/getProcessPrediction", params).then(({data}) => {
                // console.log("==================================");
                // console.log(data);

                var code = data.code;
                if(code != '1') {
                    //返回失败
                    this.returnflag = false;
                } else {
                  this.flowData = data.data.data;
                }

            });

        }
    },
    /**
     * 初始化
     */
    created(){

        // console.info("===初始化===");

    },
    mounted(){
        // console.info("===mounted===");
        this.loadData();
        this.clientWidth= document.body.clientWidth;
    }
}



// WEBPACK FOOTER //
// ./src/pcpage/process/stepsFlow.vue